import React, { Component } from "react";
import {
  company,
  loading,
  float,
  NavbarWarehouse,
  Pagination,
  Modal,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  t,
  Select,
  ActionIconButton,
  ACTION_ICONS
} from "../../components/CustomComponent.js";
import { can } from "../../utils/permission";
import { formatNumber } from "../../utils/formatting";

export default class BranchesManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_status: "",

      modal_create: false,
      modal_update: false,
      count: 0,

      // Form States (Modal)
      uid: "",
      company_id: company?.id || "", // Default company_id
      name: "",
      is_active: "Active",

      // List Data
      data: [],
    };
  }

  async componentDidMount() {
    loading(false);
    this.Get(1);
  }

  Get = async (page) => {
    const { filter_search } = this.state;
    let data, count;
    loading(true);

    // Call GET API Branches
    let result = await GET("warehouse/branches", {
        page_size: 10,
        page: page,
        data_search: filter_search || "",
        is_active: this.state.filter_status || "",
    });

    if (result?.status) {
      data = result.data || [];
      count = result.pagination?.count || 0;
    }

    this.setState({ data: data || [], count });
    loading(false);
  };

  CreateUpdate = async () => {
    const {
      uid,
      company_id,
      name,
      is_active,
    } = this.state;

    // Validation
    if (!name.trim()) {
      alert("", "warning", t("warning"), t("verify_branch"));
      return;
    }

    if (
      await alert(
        "",
        "info",
        t("confirm"),
        t("confirm_submission"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);

      // Request Body
      let body = {
        company_id,
        name,
        is_active: is_active === "Active",
      };

      // Call API
      let result = !uid
        ? await POST("warehouse/branches", body)
        : await PUT("warehouse/branches/" + uid, body);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create: false, modal_update: false }, () => {
            this.Get(1); // Refresh data
        });
      } else {
        alert(
          "",
          "warning",
          t("warning"),
          result?.message || t("error_occurred"),
        );
      }
      loading(false);
    }
  };

  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        t("delete_item"),
        t("delete_desc"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      let result = await DELETE("warehouse/branches/" + id, null);
      if (result?.status) {
        alert("#", "success");
        this.Get(1); // Refresh data after delete
      }
      loading(false);
    }
  };

  resetForm = () => {
    this.setState({
      uid: "",
      name: "",
      is_active: "Active",
    });
  };

  render() {
    const {
      data,
      count,
      filter_search,
      filter_status,
      modal_create,
      modal_update,
      name,
      is_active,
    } = this.state;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarWarehouse />
            <div className="body p-4 mt-3">
                {/* Header Section */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1 text-dark">{t("branches_management")}</h3>
                        <div className="text-secondary text-14">{t("manage_branches_desc")}</div>
                    </div>
                </div>

                {/* Main White Container */}
                <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
                    {/* Top Filter Toolbar */}
                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                        <div className="d-flex gap-2 flex-wrap">
                            <div className="position-relative" style={{ maxWidth: "300px", width: "100%" }}>
                                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                                <input
                                    type="text"
                                    className="form-control ps-5 wpx-300"
                                    style={{ height: "38px" }}
                                    placeholder={t("search_branches")}
                                    value={filter_search}
                                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                                    onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                                />
                            </div>
                            <Select
                                className="form-control wpx-150"
                                options={[
                                    { value: "true", label: t("active") },
                                    { value: "false", label: t("inactive") },
                                ]}
                                value={filter_status}
                                onChange={(e) => this.setState({ filter_status: e })}
                                placeholder={t("all_status")}
                                defaultLabel={t("all_status")}
                            />
                            <div className="d-flex gap-2">
                              <button
                                className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm"
                                onClick={() => this.Get(1)}
                              >
                                {t("filter")}
                              </button>
                              <button
                                className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                                onClick={() => this.setState({ filter_search: "", filter_status: "" }, () => this.Get(1))}
                              >
                                {t("clear_all")}
                              </button>
                            </div>
                        </div>
                        {can("branch.create") && (
                            <button
                            className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                            onClick={() => {
                                this.resetForm();
                                this.setState({ modal_create: true, name: "", is_active: "Active" });
                            }}
                        >
                            <span className="me-2 text-16">+</span> {t("add_branches")}
                        </button>
                        )}
                    </div>
                </div>

                <div className="bg-white rounded-4 shadow-sm mb-4 overflow-hidden">
                    {/* Branches Table */}
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                            <thead>
                                <tr className="text-dark fw-bold text-12 border-bottom border-light">
                                    <th className="py-3 border-0 wpx-250">{t("branch")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("status")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("actions")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, idx) => (
                                    <tr key={idx} className="border-bottom border-light bg-white">
                                        {/* Branch Info */}
                                        <td className="py-3">
                                            <div className="d-flex align-items-center">
                                                <div
                                                    className={`wpx-35 hpx-35 rounded-circle text-white d-flex align-items-center justify-content-center me-3 flex-shrink-0 fw-bold text-12 bg-primary`}
                                                >
                                                    <span className="icon">{"\uf3c5"}</span>
                                                </div>
                                                <div>
                                                    <div className="fw-bold text-dark text-14">{item.name}</div>
                                                </div>
                                            </div>
                                        </td>

                                        {/* Status */}
                                        <td className="text-center">
                                            {item.is_active ? (
                                                <span className="text-success text-12 fw-bold bg-success-light px-2 py-1 rounded-pill">{t("active")}</span>
                                            ) : (
                                                <span className="text-secondary text-12 fw-bold bg-light px-2 py-1 rounded-pill border">{t("inactive")}</span>
                                            )}
                                        </td>

                                        {/* Actions */}
                                        <td className="text-center">
                                            <div className="d-flex align-items-center gap-2 justify-content-center">
                                                {can("branch.update") && (
                                                    <ActionIconButton
                                                    label={t("edit")}
                                                    icon={ACTION_ICONS.edit}
                                                    variant="warning"
                                                    onClick={() => {
                                                        this.setState({
                                                            modal_update: true,
                                                            ...item,
                                                            is_active: item.is_active ? "Active" : "Inactive",
                                                        });
                                                    }}
                                                />
                                                )}
                                                {can("branch.delete") && (
                                                    <ActionIconButton
                                                    label={t("delete")}
                                                    icon={ACTION_ICONS.delete}
                                                    variant="danger"
                                                    onClick={() => {
                                                        this.Delete(item.uid);
                                                    }}
                                                />
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12">
                    <div>
                        {t("showing")} {data.length > 0 ? 1 : 0}-{data.length} {t("of")} {formatNumber(count)} {t("categories_count")}
                    </div>
                    <Pagination className="mb-0" count={Math.ceil(count / 10) || 1} showFirstButton={false} showLastButton={false} onChange={(_, page) => this.Get(page)} />
                </div>
            </div>

            {/* MODAL: ADD/EDIT BRANCH */}
            <Modal
                size="md"
                show={modal_create || modal_update}
                onHide={() => this.setState({ modal_create: false, modal_update: false })}
                centered
                contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
            >
                <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
                    <h5 className="fw-bold mb-0 text-dark">{modal_update ? t("edit_branches") : t("add_new_branches")}</h5>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
                    <div className="row g-4">
                        {/* Basic Information */}
                        <div className="col-12">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf05a"}</span> {t("basic_information")}
                            </h6>
                            <small className="text-muted d-block mb-3">{t("branches_basic_info_desc")}</small>
                            <div className="row g-3">
                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("branch")} <span className="text-danger">*</span>
                                    </label>
                                    <input type="text" maxLength={200} className="form-control py-2" placeholder="e.g. BPSA, BPSB" value={name} onChange={(e) => this.setState({ name: e.target.value })} />
                                    <small className="text-muted d-block text-end mt-1">{(name || "").length}/200</small>
                                </div>
                            </div>
                        </div>

                        {/* Status */}
                        <div className="col-12 mt-2 border-top pt-4">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf772"}</span> {t("status")}
                            </h6>
                            <div className="d-flex gap-4 mt-3">
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="branchStatus"
                                        id="statusActive"
                                        checked={is_active === "Active"}
                                        onChange={() => this.setState({ is_active: "Active" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="statusActive">
                                        {t("active")}
                                    </label>
                                </div>
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="branchStatus"
                                        id="statusInactive"
                                        checked={is_active === "Inactive"}
                                        onChange={() => this.setState({ is_active: "Inactive" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="statusInactive">
                                        {t("inactive")}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
                    <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
                        {t("cancel")}
                    </button>
                    <button
                        className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
                        onClick={() => {
                            this.CreateUpdate();
                        }}
                    >
                        <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
